import { Toaster, TooltipProvider } from '@iq/ui';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { i18next } from './i18n.js';
import { FontSizeProvider } from './lib/font-size.js';
import { queryClient } from './lib/query-client.js';
import { router } from './lib/router.js';
import { ThemeProvider } from './lib/theme.js';
import './styles/globals.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('root element missing');

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <I18nextProvider i18n={i18next}>
        <ThemeProvider>
          <FontSizeProvider>
            <TooltipProvider delayDuration={150}>
              <RouterProvider router={router} />
              <Toaster richColors closeButton position="bottom-right" />
            </TooltipProvider>
          </FontSizeProvider>
        </ThemeProvider>
      </I18nextProvider>
    </QueryClientProvider>
  </StrictMode>,
);
